import { BalanceSheetEntitySettingsKeys } from '@widgets/new-manage-balance-sheets-accounts-modal/components/balance-sheet-account-grid/grid-config/grid-config-context';

import { listEntitySettingsQuery } from '@shared/services/gql.service';
import { getEncodedAttributeName } from '@shared/utils/get-encoded-attribute-name';

import { BalanceSheetAccountView } from './grid-config-context';

interface BalanceSheetAccountDetail {
  [key: string]: unknown;
  attributes?: { [key: string]: string };
  PROGRAM?: string;
  PROJECT?: string;
}

interface ParsedVendorSettings {
  [accountType: string]: BalanceSheetAccountDetail;
}

export const forcedTooltip = 'Click Edit button in top right corner to edit.';

export const buildBalanceSheetAccountRows = (
  allVendorsData: listEntitySettingsQuery[],
  jeApManualClearing: boolean
): BalanceSheetAccountView[] => {
  const rows: BalanceSheetAccountView[] = [];

  allVendorsData.forEach((vendorData) => {
    let parsedSettings: ParsedVendorSettings = {};

    try {
      if (vendorData.settings) {
        parsedSettings = JSON.parse(vendorData.settings) as ParsedVendorSettings;
      }
    } catch (e) {
      console.error(`Error parsing settings for vendor ${vendorData.entity_id}:`, e);

      return;
    }

    const accountTypes = [
      BalanceSheetEntitySettingsKeys.ACCRUED_LIABILITIES,
      BalanceSheetEntitySettingsKeys.PREPAID_EXPENSES,
      BalanceSheetEntitySettingsKeys.LONG_TERM_PREPAID,
      BalanceSheetEntitySettingsKeys.ACCOUNTS_PAYABLE,
    ];

    for (const accountType of accountTypes) {
      // If the journal entry AP manual clearing flag is not enabled, we don't want to show the accounts payable account
      if (!jeApManualClearing && accountType === BalanceSheetEntitySettingsKeys.ACCOUNTS_PAYABLE) {
        continue;
      }

      const accountDetail = parsedSettings[accountType] || {};
      const encodedAttributes: { [key: string]: string } = {};

      for (const originalAttrName in accountDetail.attributes) {
        const encodedName = getEncodedAttributeName(originalAttrName);

        encodedAttributes[encodedName] = accountDetail.attributes[originalAttrName];
      }

      rows.push({
        attributes: encodedAttributes,
        program: accountDetail.PROGRAM || '',
        project: accountDetail.PROJECT || '',
        type: accountType,
        vendorId: vendorData.entity_id,
      });
    }
  });

  return rows;
};
